interface FormCapabilities {
  hasEmploymentDetails: boolean
  hasEmergencyContacts: boolean
  hasPetDetails: boolean
  hasStudentDetails: boolean
}

interface GetDisabledSectionsOptions {
  isTicaActive: boolean
  ballotsEnabled: boolean
  isQLDForm22: boolean
  resolvedFormCapabilities: FormCapabilities
}

/**
 * Computes which sections should be disabled in the applicant details sidebar menu.
 *
 * Background Check menu always shows (except when ballots enabled).
 * The actual background check data visibility is controlled by the API.
 */
export const getDisabledSections = ({
  isTicaActive,
  ballotsEnabled,
  isQLDForm22,
  resolvedFormCapabilities,
}: GetDisabledSectionsOptions): string[] => {
  const disabledSections: string[] = []

  // TICA check - disabled when TICA integration is not active
  if (!isTicaActive) {
    disabledSections.push('ticaCheck')
  }

  // Background check - only disabled when ballots are enabled
  if (ballotsEnabled) {
    disabledSections.push('backgroundCheck')
  }

  // QLD Form 22 always disables studentDetails and emergencyContact (takes precedence)
  if (isQLDForm22) {
    disabledSections.push('studentDetails', 'emergencyContact')
  } else {
    // Form capabilities only apply for non-QLD forms
    if (!resolvedFormCapabilities.hasEmergencyContacts) {
      disabledSections.push('emergencyContact')
    }
    if (!resolvedFormCapabilities.hasStudentDetails) {
      disabledSections.push('studentDetails')
    }
  }

  // Employment details - form capability check (applies to all forms)
  if (!resolvedFormCapabilities.hasEmploymentDetails) {
    disabledSections.push('employmentDetails')
  }

  // Pet details - form capability check (applies to all forms)
  if (!resolvedFormCapabilities.hasPetDetails) {
    disabledSections.push('petDetails')
  }

  return disabledSections
}
